import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import emailjs from '@emailjs/browser';
import { db } from '../../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';

// Initialize EmailJS at module load
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

const ContactForm = () => {
  const [forms, setForms] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));
  const [, forceUpdate] = useState(false); // re-render trigger for validator

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages();
    forceUpdate(v => !v);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      try {
        // 1️⃣ Send email via EmailJS
        await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          forms,
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );

        // 2️⃣ Save submission to Firestore
        await addDoc(collection(db, 'contactForms'), forms);

        alert('✅ Message sent and saved successfully!');
        setForms({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
        validator.hideMessages();
        forceUpdate(v => !v);
      } catch (error) {
        console.error('❌ Error:', error);
        alert('❌ Failed to send/save message, please try again.');
      }
    } else {
      validator.showMessages();
      forceUpdate(v => !v);
    }
  };

  return (
    <form onSubmit={submitHandler} className="contact-validation-active">
      <div className="row">
        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Name"
            />
            {validator.message('name', forms.name, 'required|alpha_space')}
          </div>
        </div>

        <div className="col col-lg-6 col-12">
          <div className="form-field">
            <input
              value={forms.email}
              type="email"
              name="email"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Email"
            />
            {validator.message('email', forms.email, 'required|email')}
          </div>
        </div>

        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <input
              value={forms.phone}
              type="tel"
              name="phone"
              onBlur={changeHandler}
              onChange={changeHandler}
              placeholder="Your Phone"
            />
            {validator.message('phone', forms.phone, 'required|numeric|min:10|max:15')}
          </div>
        </div>

        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <select
              onBlur={changeHandler}
              onChange={changeHandler}
              value={forms.subject}
              name="subject"
            >
              <option value="">Choose a Service</option>
              <option value="Web Design">Design</option>
              <option value="Web Development">Development</option>
              <option value="Marketing">Marketing</option>
            </select>
            {validator.message('subject', forms.subject, 'required')}
          </div>
        </div>

        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <textarea
              onBlur={changeHandler}
              onChange={changeHandler}
              value={forms.message}
              name="message"
              placeholder="Message"
            />
            {validator.message('message', forms.message, 'required')}
          </div>
        </div>
      </div>

      <div className="submit-area">
        <button type="submit" className="theme-btn">Submit Now</button>
      </div>
    </form>
  );
};

export default ContactForm;
